import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {DASHBOARD_QUERY_KEY} from "../queryKeys";

type Params = {[key: string]: string};

type Variables = {
  dashboardName: string;
  params?: Params;
};

type Data = string;

export const getEmbeddedDashboardURL = async (variables: Variables): Promise<Data> => {
  const url = await axiosReachInstance.get(`dashboards/embedded/${variables.dashboardName}`, {
    params: variables.params,
  });
  return url.data;
};

export const useGetEmbeddedDashboardURL = (
  variables: Variables,
  options?: BaseQueryOptions<Data, Variables>
): BaseUseQueryResult<Data> =>
  useBaseQuery<Data, Variables>(
    [DASHBOARD_QUERY_KEY, variables.dashboardName, JSON.stringify(variables.params)],
    getEmbeddedDashboardURL,
    variables,
    options
  );
